import { render, staticRenderFns } from "./HelpDeskTechnicianRequests.vue?vue&type=template&id=f050319e&scoped=true&"
import script from "./HelpDeskTechnicianRequests.vue?vue&type=script&lang=js&"
export * from "./HelpDeskTechnicianRequests.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskTechnicianRequests.vue?vue&type=style&index=0&id=f050319e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f050319e",
  null
  
)

export default component.exports